import { render, staticRenderFns } from "./My-6-Completed.vue?vue&type=template&id=f85dfb4e&scoped=true&"
import script from "./My-6-Completed.vue?vue&type=script&lang=js&"
export * from "./My-6-Completed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85dfb4e",
  null
  
)

export default component.exports